// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__bTGiE","logop":"Footer_logop__dpCs4","ig":"Footer_ig__RWFLk","imgig":"Footer_imgig__8XCfB","txtfooter":"Footer_txtfooter__MqPj2"};